export default "__VITE_ASSET__69f4c249__"